import { Link } from "react-router-dom";
import React from "react";
import "../styles/HRPayrollServices.css";
import hr1 from "../assets/services/hr 1.jpeg";
import hr2 from "../assets/services/hr 2.jpeg";

const solutions = [
  {
    title: "Payroll Management",
    description:
      "Manage employee payroll processes accurately with organized salary, attendance and payroll administration.",
  },
  {
    title: "HR Operations",
    description:
      "Support everyday HR activities including employee records, documentation and organizational processes.",
  },
  {
    title: "Recruitment Support",
    description:
      "Assist businesses with structured recruitment activities to help identify and connect with suitable candidates.",
  },
  {
    title: "Employee Records",
    description:
      "Maintain organized employee information and documentation for smoother HR administration.",
  },
  {
    title: "Attendance Management",
    description:
      "Support attendance tracking and related workforce administration through structured processes.",
  },
  {
    title: "HR Documentation",
    description:
      "Create and maintain important HR documents and processes required for effective workforce management.",
  },
];

const process = [
  {
    title: "Understand",
    description:
      "We understand your workforce structure, HR requirements and existing processes.",
  },
  {
    title: "Organize",
    description:
      "We structure employee information, documentation and administrative workflows.",
  },
  {
    title: "Manage",
    description:
      "We support everyday HR and payroll activities through consistent processes.",
  },
  {
    title: "Improve",
    description:
      "We review workflows and identify opportunities to make HR operations more efficient.",
  },
];

function HRPayrollServices() {
  return (
    <main className="hr-page">

      <section className="hr-hero">
        <div className="hr-hero-content">
          <span className="hr-eyebrow">HR & PAYROLL SERVICES</span>

          <h1>
            Make People
            <span> Operations Simpler</span>
          </h1>

          <p>
            Organize HR operations, payroll and workforce
            administration with structured services designed
            to support your growing team.
          </p>

          <a href="#hr-solutions" className="hr-primary-btn">
            Explore HR Services
            <span>→</span>
          </a>
        </div>

        <div className="hr-hero-visual">
          <div className="hr-hero-image">
            <img
              src={hr1}
              alt="HR business team"
            />
          </div>
        </div>
      </section>

      <section className="hr-intro">
        <div className="hr-intro-header">
          <div className="hr-intro-label">
            <span>01</span>
            <p>WHAT WE MANAGE</p>
          </div>

          <div className="hr-intro-heading">
            <h2>
              Better workforce management
              <span> starts with organized processes</span>
            </h2>

            <p>
              We support HR teams with practical payroll,
              recruitment, employee administration and workforce
              management services.
            </p>
          </div>
        </div>

        <div className="hr-intro-content">
          <div className="hr-intro-main">
            <span>OUR APPROACH</span>

            <h3>
              HR operations should be
              <strong> clear, accurate and organized</strong>
            </h3>

            <p>
              We help simplify repetitive HR activities and
              administrative processes so organizations can
              focus more on their people and business priorities.
            </p>
          </div>

          <div className="hr-intro-points">
            <div className="hr-intro-point">
              <span>01</span>
              <div>
                <h4>Organized information</h4>
                <p>
                  Keep employee records and HR documentation
                  structured and accessible.
                </p>
              </div>
            </div>

            <div className="hr-intro-point">
              <span>02</span>
              <div>
                <h4>Accurate processes</h4>
                <p>
                  Support payroll and workforce activities with
                  consistent administrative workflows.
                </p>
              </div>
            </div>

            <div className="hr-intro-point">
              <span>03</span>
              <div>
                <h4>People focused</h4>
                <p>
                  Reduce administrative pressure and create
                  smoother experiences for employees and HR teams.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="hr-solutions" id="hr-solutions">
        <div className="hr-section-heading">
          <div>
            <span className="hr-small-label">HR SERVICES</span>

            <h2>
              Explore our
              <span> workforce solutions</span>
            </h2>
          </div>

          <p>
            Practical HR and payroll services that help businesses
            manage workforce operations more efficiently.
          </p>
        </div>

        <div className="hr-solutions-grid">
          {solutions.map((item) => (
            <article className="hr-solution-card" key={item.title}>
              <div className="hr-card-content">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="hr-tech-section">
        <div className="hr-tech-content">
          <span className="hr-small-label">WORKFORCE MANAGEMENT</span>

          <h2>
            Give your HR team
            <span> more time for people</span>
          </h2>

          <p>
            Better HR processes reduce repetitive administration
            and help teams spend more time on employee engagement,
            development and business priorities.
          </p>

          <div className="hr-tech-points">
            <div>
              <strong>01</strong>
              <h4>Simplified administration</h4>
              <p>
                Organize everyday HR activities through clear
                and repeatable workflows.
              </p>
            </div>

            <div>
              <strong>02</strong>
              <h4>Reliable records</h4>
              <p>
                Maintain employee information and documentation
                in a structured manner.
              </p>
            </div>

            <div>
              <strong>03</strong>
              <h4>Efficient workforce</h4>
              <p>
                Reduce administrative workload and improve
                workforce management processes.
              </p>
            </div>
          </div>
        </div>

        <div className="hr-tech-visual">
          <div className="hr-tech-image">
            <img
              src={hr2}
              alt="HR team discussion"
            />
          </div>
        </div>
      </section>

      <section className="hr-process">
        <div className="hr-process-heading">
          <span className="hr-small-label">HOW WE WORK</span>

          <h2>
            Organized HR.
            <span> Better operations</span>
          </h2>

          <p>
            We use a structured process to understand your HR
            requirements and build practical workforce support.
          </p>
        </div>

        <div className="hr-process-grid">
          {process.map((item, index) => (
            <article className="hr-process-item" key={item.title}>
              <div className="hr-process-number">
                {String(index + 1).padStart(2, "0")}
              </div>

              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="hr-final">
        <div className="hr-final-content">
          <div className="hr-final-main">
            <div className="hr-final-label">
              <span></span>
              SUPPORT YOUR PEOPLE
            </div>

            <h2>
              Build simpler
              <span> HR operations</span>
            </h2>

            <p>
              Tell us about your workforce or HR requirements.
              We can help you explore practical ways to organize
              your people operations.
            </p>
          </div>

          <div className="hr-final-action">
            <div className="hr-final-brand">
              <strong>TECHLYNX INNOVATIONS</strong>
              <p>People · Process · Growth</p>
            </div>

            <Link
              to="/contact"
              className="hr-final-btn"
            >
              Start a conversation
              <span>↗</span>
            </Link>
          </div>
        </div>
      </section>

    </main>
  );
}

export default HRPayrollServices;